import loadable from '@loadable/component';

export const namespace = 'canalplus.block.formConfirmation';
export const Component = loadable(
  () => import('./components/FormConfirmation')
);
export { default as propsFormatter } from './propsFormatter';
